import React from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import fileDownload from "js-file-download";
import { Button } from "../../../../components/simple";
import { audiences } from "../../../../router/routes";
import SVG from "../../../../components/SVG";

import styles from "../push-modal.module.scss";
import API from "../../../../api";

const Congratulations = ({
  isSuccess,
  onClose,
  audience,
  audienceType,
  clientId
}) => {
  const { error, successResponseMessage } = useSelector(
    state => state.platforms
  );
  const history = useHistory();
  const location = useLocation();

  const errorMsg = typeof error === "string" ? error : "Something went wrong";

  const handleClick = () => {
    if (location.pathname === "/audiences") onClose();
    history.push(audiences(null));
  };

  const downloadPostalcodes = async () => {
    const response = await API.platforms.postalCodes.download({
      audienceType,
      audienceValue: audience?.id,
      clientId
    });
    fileDownload(response, `${audience.name}-ZIP.csv`);
  };
  return (
    <div
      className={`${styles.congratulations} ${
        isSuccess ? styles["slide-from-right"] : ""
      }`}
    >
      {!error ? (
        <div className={styles.congrats_container}>
          <div className={styles.svg_container}>
            <SVG.SuccessSvg />
          </div>
          <div className={styles.title}>
            {successResponseMessage ||
              "Your audience is pushed to the platform"}
            <Button
              className={styles["platform-signin-button"]}
              onClick={handleClick}
              style={{ width: 139 }}
            >
              HOME
            </Button>
          </div>
        </div>
      ) : (
        <div className={styles.error_container}>
          <div className={styles.icon_container}>
            <BugIcon />
          </div>

          <div className={styles.blue_container}>
            <div>An error happened:</div>
            <div>{errorMsg}</div>
            <Button
              type="button"
              // className={styles["platform-signin-button"]}
              onClick={downloadPostalcodes}
            >
              Upload audience manually
            </Button>
            <div>
              <span>Here are some helpful links:</span>
            </div>
            <div className={styles.link_row}>
              <a
                style={{ textDecoration: "underline", color: "#252525" }}
                href="/"
                target="_blank"
                rel="noopener"
              >
                Errors
              </a>
              <a
                style={{
                  textDecoration: "underline",
                  color: "#252525",
                  margin: "0 15px"
                }}
                href="/"
                target="_blank"
              >
                Guide
              </a>
              <a
                style={{ textDecoration: "underline", color: "#252525" }}
                href="/"
                target="_blank"
              >
                Support
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Congratulations.propTypes = {
  isSuccess: PropTypes.bool,
  audience: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string
  }),
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  onClose: PropTypes.func,
  audienceType: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired
};

Congratulations.defaultProps = {
  isSuccess: false,
  audience: { name: "" },
  onClose: () => {}
};

export default Congratulations;

const BugIcon = props => (
  <svg
    width="150"
    height="103"
    viewBox="0 0 150 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M150 92.8302V9.62264C149.996 7.07167 148.981 4.62621 147.178 2.82239C145.374 1.01858 142.928 0.00360942 140.377 0H9.62264C7.07167 0.00361042 4.62621 1.01858 2.8224 2.82239C1.01859 4.62621 0.00361042 7.07167 0 9.62264V92.8302C0.00361042 95.3812 1.01859 97.8266 2.8224 99.6304C4.62621 101.434 7.07167 102.449 9.62264 102.453H140.377C142.928 102.449 145.374 101.434 147.178 99.6304C148.981 97.8266 149.996 95.3812 150 92.8302ZM9.62264 101.321C7.37164 101.318 5.21362 100.423 3.62193 98.8309C2.03023 97.2392 1.13482 95.0812 1.13208 92.8302V9.62264C1.13482 7.37164 2.03023 5.21362 3.62193 3.62193C5.21362 2.03023 7.37164 1.13481 9.62264 1.13207H140.377C142.628 1.13481 144.786 2.03023 146.378 3.62193C147.97 5.21362 148.865 7.37164 148.868 9.62264V92.8302C148.865 95.0812 147.97 97.2392 146.378 98.8309C144.786 100.423 142.628 101.318 140.377 101.321H9.62264Z"
      fill="#3F3D56"
    />
    <path
      d="M148.868 14.9708H1.13219C0.982069 14.9708 0.838101 14.9112 0.73195 14.805C0.625798 14.6989 0.566162 14.5549 0.566162 14.4048C0.566162 14.2547 0.625798 14.1107 0.73195 14.0045C0.838101 13.8984 0.982069 13.8387 1.13219 13.8387H148.868C149.018 13.8387 149.162 13.8984 149.268 14.0045C149.374 14.1107 149.434 14.2547 149.434 14.4048C149.434 14.5549 149.374 14.6989 149.268 14.805C149.162 14.9112 149.018 14.9708 148.868 14.9708Z"
      fill="#3F3D56"
    />
    <path
      d="M10.755 10.7547C12.3181 10.7547 13.5852 9.48762 13.5852 7.92455C13.5852 6.36148 12.3181 5.09436 10.755 5.09436C9.19192 5.09436 7.9248 6.36148 7.9248 7.92455C7.9248 9.48762 9.19192 10.7547 10.755 10.7547Z"
      fill="#063AC9"
    />
    <path
      d="M20.3768 10.7547C21.9399 10.7547 23.207 9.48762 23.207 7.92455C23.207 6.36148 21.9399 5.09436 20.3768 5.09436C18.8138 5.09436 17.5466 6.36148 17.5466 7.92455C17.5466 9.48762 18.8138 10.7547 20.3768 10.7547Z"
      fill="#063AC9"
    />
    <path
      d="M30.0001 10.7547C31.5632 10.7547 32.8303 9.48762 32.8303 7.92455C32.8303 6.36148 31.5632 5.09436 30.0001 5.09436C28.437 5.09436 27.1699 6.36148 27.1699 7.92455C27.1699 9.48762 28.437 10.7547 30.0001 10.7547Z"
      fill="#063AC9"
    />
    <path
      d="M51.151 75.889C51.101 75.889 51.0515 75.8791 51.0053 75.86C50.959 75.8409 50.917 75.8128 50.8817 75.7774C50.8463 75.7421 50.8182 75.7001 50.7991 75.6538C50.78 75.6076 50.7701 75.5581 50.7701 75.5081C50.7701 71.5364 49.0291 69.3213 46.2201 67.0339C46.1811 67.0024 46.1488 66.9635 46.1249 66.9195C46.101 66.8754 46.0861 66.8271 46.0809 66.7773C46.0757 66.7274 46.0804 66.677 46.0948 66.629C46.1091 66.581 46.1327 66.5363 46.1644 66.4974C46.196 66.4586 46.235 66.4264 46.2791 66.4026C46.3232 66.3788 46.3716 66.364 46.4215 66.359C46.4713 66.3539 46.5217 66.3588 46.5696 66.3733C46.6176 66.3877 46.6623 66.4115 46.701 66.4432C49.6836 68.8715 51.532 71.2351 51.532 75.5081C51.532 75.5581 51.5221 75.6076 51.503 75.6538C51.4839 75.7001 51.4558 75.7421 51.4204 75.7774C51.385 75.8128 51.3431 75.8409 51.2968 75.86C51.2506 75.8791 51.2011 75.889 51.151 75.889Z"
      fill="black"
    />
    <path
      d="M18.5215 75.889C18.4715 75.889 18.422 75.8791 18.3758 75.86C18.3295 75.8409 18.2875 75.8128 18.2522 75.7774C18.2168 75.7421 18.1887 75.7001 18.1696 75.6538C18.1505 75.6076 18.1406 75.5581 18.1406 75.5081C18.1406 71.2351 19.989 68.8715 22.9716 66.4432C23.0103 66.4115 23.055 66.3877 23.1029 66.3733C23.1509 66.3588 23.2013 66.3539 23.2511 66.359C23.301 66.364 23.3493 66.3788 23.3935 66.4026C23.4376 66.4264 23.4766 66.4586 23.5082 66.4974C23.5398 66.5363 23.5635 66.581 23.5778 66.629C23.5921 66.677 23.5969 66.7274 23.5917 66.7773C23.5865 66.8271 23.5716 66.8754 23.5477 66.9195C23.5238 66.9635 23.4915 67.0024 23.4525 67.0339C20.6435 69.3213 18.9024 71.5368 18.9024 75.5081C18.9025 75.5581 18.8926 75.6076 18.8735 75.6538C18.8543 75.7001 18.8263 75.7421 18.7909 75.7774C18.7555 75.8128 18.7135 75.8409 18.6673 75.86C18.6211 75.8791 18.5716 75.889 18.5215 75.889Z"
      fill="black"
    />
    <path
      d="M47.8889 49.7854C47.8102 49.7855 47.7335 49.7611 47.6692 49.7158C47.6049 49.6705 47.5562 49.6064 47.5299 49.5323C47.5035 49.4581 47.5007 49.3777 47.5219 49.3019C47.5431 49.2262 47.5872 49.1589 47.6482 49.1092C50.5357 46.7584 50.7706 43.419 50.7706 39.6157C50.7706 39.5146 50.8107 39.4177 50.8822 39.3463C50.9536 39.2749 51.0505 39.2347 51.1515 39.2347C51.2525 39.2347 51.3494 39.2749 51.4209 39.3463C51.4923 39.4177 51.5324 39.5146 51.5324 39.6157C51.5324 43.6171 51.2763 47.1377 48.1292 49.6999C48.0614 49.7553 47.9764 49.7856 47.8889 49.7854Z"
      fill="black"
    />
    <path
      d="M21.7844 49.5816C21.6968 49.5817 21.6119 49.5515 21.5441 49.4961C18.3967 46.9337 18.1406 43.5055 18.1406 39.6157C18.1406 39.5146 18.1808 39.4177 18.2522 39.3463C18.3236 39.2749 18.4205 39.2347 18.5215 39.2347C18.6226 39.2347 18.7194 39.2749 18.7909 39.3463C18.8623 39.4177 18.9024 39.5146 18.9024 39.6157C18.9024 43.4387 19.1323 46.5503 22.025 48.9053C22.086 48.955 22.1302 49.0223 22.1513 49.0981C22.1725 49.1738 22.1697 49.2543 22.1434 49.3284C22.117 49.4025 22.0683 49.4666 22.004 49.512C21.9398 49.5573 21.863 49.5816 21.7844 49.5816V49.5816Z"
      fill="black"
    />
    <path
      d="M56.0461 57.9563H47.8887C47.7877 57.9563 47.6908 57.9162 47.6194 57.8447C47.5479 57.7733 47.5078 57.6764 47.5078 57.5754C47.5078 57.4743 47.5479 57.3775 47.6194 57.306C47.6908 57.2346 47.7877 57.1945 47.8887 57.1945H56.0461C56.1471 57.1945 56.244 57.2346 56.3154 57.306C56.3869 57.3775 56.427 57.4743 56.427 57.5754C56.427 57.6764 56.3869 57.7733 56.3154 57.8447C56.244 57.9162 56.1471 57.9563 56.0461 57.9563Z"
      fill="black"
    />
    <path
      d="M21.7849 57.9563H13.6275C13.5265 57.9563 13.4296 57.9162 13.3582 57.8447C13.2867 57.7733 13.2466 57.6764 13.2466 57.5754C13.2466 57.4743 13.2867 57.3775 13.3582 57.306C13.4296 57.2346 13.5265 57.1945 13.6275 57.1945H21.7849C21.8859 57.1945 21.9828 57.2346 22.0542 57.306C22.1257 57.3775 22.1658 57.4743 22.1658 57.5754C22.1658 57.6764 22.1257 57.7733 22.0542 57.8447C21.9828 57.9162 21.8859 57.9563 21.7849 57.9563Z"
      fill="black"
    />
    <path
      d="M34.8362 74.2575C34.7862 74.2575 34.7367 74.2477 34.6904 74.2286C34.6442 74.2094 34.6022 74.1814 34.5669 74.146C34.5315 74.1106 34.5034 74.0686 34.4843 74.0224C34.4652 73.9762 34.4553 73.9266 34.4553 73.8766V47.773C34.4553 47.672 34.4955 47.5751 34.5669 47.5036C34.6383 47.4322 34.7352 47.3921 34.8362 47.3921C34.9373 47.3921 35.0341 47.4322 35.1056 47.5036C35.177 47.5751 35.2171 47.672 35.2171 47.773V73.8766C35.2172 73.9266 35.2073 73.9762 35.1882 74.0224C35.169 74.0686 35.141 74.1106 35.1056 74.146C35.0702 74.1814 35.0282 74.2094 34.982 74.2286C34.9358 74.2477 34.8863 74.2575 34.8362 74.2575Z"
      fill="black"
    />
    <path
      d="M34.8362 74.2578C31.2749 74.2537 27.8606 72.8372 25.3423 70.3189C22.8241 67.8006 21.4076 64.3863 21.4036 60.825V51.029C21.4036 44.7561 26.5507 40.8593 34.8362 40.8593C43.4985 40.8593 48.269 44.471 48.269 51.029V60.825C48.265 64.3864 46.8484 67.8007 44.3302 70.319C41.8119 72.8372 38.3975 74.2538 34.8362 74.2578ZM34.8362 41.6211C28.7108 41.6211 22.1654 44.0925 22.1654 51.029V60.825C22.1645 62.4895 22.4915 64.138 23.1279 65.6761C23.7643 67.2142 24.6974 68.6118 25.8741 69.7892C27.0508 70.9665 28.448 71.9005 29.9857 72.5377C31.5235 73.1749 33.1717 73.5028 34.8363 73.5028C36.5008 73.5028 38.1491 73.1749 39.6868 72.5377C41.2246 71.9005 42.6217 70.9665 43.7984 69.7892C44.9751 68.6118 45.9083 67.2142 46.5447 65.6761C47.181 64.138 47.5081 62.4895 47.5072 60.825V51.029C47.5072 42.8434 39.5684 41.6211 34.8362 41.6211Z"
      fill="black"
    />
    <path
      d="M27.0295 43.2108C26.9532 43.2108 26.8787 43.188 26.8157 43.1452C26.7526 43.1024 26.7037 43.0417 26.6755 42.9709C26.4555 42.4203 26.3283 41.837 26.2991 41.2447C26.3057 38.9865 27.2044 36.8223 28.7993 35.2235C30.3942 33.6248 32.5562 32.7209 34.8145 32.7089H34.8582C37.1135 32.7196 39.2734 33.6202 40.8683 35.2149C42.4632 36.8096 43.3641 38.9695 43.3751 41.2248C43.3554 41.7758 43.238 42.3189 43.0284 42.8288C42.9895 42.9215 42.9155 42.9951 42.8226 43.0335C42.7296 43.0719 42.6253 43.0719 42.5323 43.0337C42.4393 42.9954 42.3652 42.922 42.3261 42.8293C42.2871 42.7366 42.2863 42.6323 42.3239 42.539C42.4978 42.1167 42.5959 41.6671 42.6136 41.2107C42.6002 39.1592 41.7782 37.1959 40.326 35.7468C38.8738 34.2977 36.9087 33.4798 34.8573 33.4707H34.8154C32.7616 33.4809 30.7949 34.3014 29.3427 35.7537C27.8905 37.2061 27.0703 39.1729 27.0603 41.2267C27.0873 41.7283 27.1964 42.2222 27.383 42.6886C27.406 42.7463 27.4145 42.8089 27.4078 42.8707C27.4011 42.9325 27.3793 42.9918 27.3444 43.0433C27.3096 43.0948 27.2627 43.1369 27.2078 43.1661C27.1529 43.1954 27.0917 43.2107 27.0295 43.2108H27.0295Z"
      fill="black"
    />
    <path
      d="M73.5229 41.139H68.952C68.2448 41.139 67.5666 40.8581 67.0666 40.358C66.5666 39.858 66.2856 39.1798 66.2856 38.4726C66.2856 37.7655 66.5666 37.0873 67.0666 36.5872C67.5666 36.0872 68.2448 35.8063 68.952 35.8063H73.5229C74.2301 35.8063 74.9083 36.0872 75.4083 36.5872C75.9084 37.0873 76.1893 37.7655 76.1893 38.4726C76.1893 39.1798 75.9084 39.858 75.4083 40.358C74.9083 40.8581 74.2301 41.139 73.5229 41.139Z"
      fill="#CCCCCC"
    />
    <path
      d="M104.757 52.3758H100.186C99.479 52.3758 98.8008 52.0949 98.3007 51.5949C97.8007 51.0948 97.5198 50.4166 97.5198 49.7095C97.5198 49.0023 97.8007 48.3241 98.3007 47.8241C98.8008 47.324 99.479 47.0431 100.186 47.0431H104.757C105.464 47.0431 106.142 47.324 106.642 47.8241C107.143 48.3241 107.423 49.0023 107.423 49.7095C107.423 50.4166 107.143 51.0948 106.642 51.5949C106.142 52.0949 105.464 52.3758 104.757 52.3758Z"
      fill="#CCCCCC"
    />
    <path
      d="M119.232 52.3758H114.661C113.954 52.3758 113.276 52.0949 112.776 51.5949C112.276 51.0948 111.995 50.4166 111.995 49.7095C111.995 49.0023 112.276 48.3241 112.776 47.8241C113.276 47.324 113.954 47.0431 114.661 47.0431H119.232C119.939 47.0431 120.617 47.324 121.117 47.8241C121.617 48.3241 121.898 49.0023 121.898 49.7095C121.898 50.4166 121.617 51.0948 121.117 51.5949C120.617 52.0949 119.939 52.3758 119.232 52.3758Z"
      fill="#CCCCCC"
    />
    <path
      d="M133.707 52.3758H129.136C128.429 52.3758 127.75 52.0949 127.25 51.5949C126.75 51.0948 126.469 50.4166 126.469 49.7095C126.469 49.0023 126.75 48.3241 127.25 47.8241C127.75 47.324 128.429 47.0431 129.136 47.0431H133.707C134.414 47.0431 135.092 47.324 135.592 47.8241C136.092 48.3241 136.373 49.0023 136.373 49.7095C136.373 50.4166 136.092 51.0948 135.592 51.5949C135.092 52.0949 134.414 52.3758 133.707 52.3758Z"
      fill="#CCCCCC"
    />
    <path
      d="M105.139 41.3294H83.8077C83.1006 41.3294 82.4223 41.0485 81.9223 40.5485C81.4223 40.0484 81.1414 39.3702 81.1414 38.6631C81.1414 37.9559 81.4223 37.2777 81.9223 36.7777C82.4223 36.2776 83.1006 35.9967 83.8077 35.9967H105.139C105.846 35.9967 106.524 36.2776 107.024 36.7777C107.524 37.2777 107.805 37.9559 107.805 38.6631C107.805 39.3702 107.524 40.0484 107.024 40.5485C106.524 41.0485 105.846 41.3294 105.139 41.3294Z"
      fill="#CCCCCC"
    />
    <path
      d="M90.2829 51.995H68.952C68.2448 51.995 67.5666 51.714 67.0666 51.214C66.5666 50.714 66.2856 50.0358 66.2856 49.3286C66.2856 48.6214 66.5666 47.9432 67.0666 47.4432C67.5666 46.9432 68.2448 46.6622 68.952 46.6622H90.2829C90.9901 46.6622 91.6683 46.9432 92.1683 47.4432C92.6684 47.9432 92.9493 48.6214 92.9493 49.3286C92.9493 50.0358 92.6684 50.714 92.1683 51.214C91.6683 51.714 90.9901 51.995 90.2829 51.995Z"
      fill="#CCCCCC"
    />
    <path
      d="M132.183 41.3294H115.804C115.097 41.3294 114.419 41.0485 113.919 40.5485C113.419 40.0484 113.138 39.3702 113.138 38.6631C113.138 37.9559 113.419 37.2777 113.919 36.7777C114.419 36.2776 115.097 35.9967 115.804 35.9967H132.183C132.891 35.9967 133.569 36.2776 134.069 36.7777C134.569 37.2777 134.85 37.9559 134.85 38.6631C134.85 39.3702 134.569 40.0484 134.069 40.5485C133.569 41.0485 132.891 41.3294 132.183 41.3294Z"
      fill="#CCCCCC"
    />
    <path
      d="M73.5229 63.6126H68.952C68.2448 63.6126 67.5666 63.3317 67.0666 62.8317C66.5666 62.3316 66.2856 61.6534 66.2856 60.9463C66.2856 60.2391 66.5666 59.5609 67.0666 59.0609C67.5666 58.5608 68.2448 58.2799 68.952 58.2799H73.5229C74.2301 58.2799 74.9083 58.5608 75.4083 59.0609C75.9084 59.5609 76.1893 60.2391 76.1893 60.9463C76.1893 61.6534 75.9084 62.3316 75.4083 62.8317C74.9083 63.3317 74.2301 63.6126 73.5229 63.6126Z"
      fill="#CCCCCC"
    />
    <path
      d="M105.139 63.8031H83.8077C83.1006 63.8031 82.4223 63.5221 81.9223 63.0221C81.4223 62.5221 81.1414 61.8439 81.1414 61.1367C81.1414 60.4295 81.4223 59.7513 81.9223 59.2513C82.4223 58.7513 83.1006 58.4703 83.8077 58.4703H105.139C105.846 58.4703 106.524 58.7513 107.024 59.2513C107.524 59.7513 107.805 60.4295 107.805 61.1367C107.805 61.8439 107.524 62.5221 107.024 63.0221C106.524 63.5221 105.846 63.8031 105.139 63.8031Z"
      fill="#CCCCCC"
    />
    <path
      d="M132.183 63.8031H115.804C115.097 63.8031 114.419 63.5221 113.919 63.0221C113.419 62.5221 113.138 61.8439 113.138 61.1367C113.138 60.4295 113.419 59.7513 113.919 59.2513C114.419 58.7513 115.097 58.4703 115.804 58.4703H132.183C132.891 58.4703 133.569 58.7513 134.069 59.2513C134.569 59.7513 134.85 60.4295 134.85 61.1367C134.85 61.8439 134.569 62.5221 134.069 63.0221C133.569 63.5221 132.891 63.8031 132.183 63.8031Z"
      fill="#CCCCCC"
    />
    <path
      d="M124.946 72.7544C124.947 72.0475 125.228 71.3697 125.728 70.8698C126.228 70.37 126.905 70.0888 127.612 70.088H132.183C132.89 70.088 133.569 70.3689 134.069 70.869C134.569 71.369 134.85 72.0472 134.85 72.7544C134.85 73.4615 134.569 74.1397 134.069 74.6398C133.569 75.1398 132.89 75.4207 132.183 75.4207H127.612C126.905 75.42 126.228 75.1388 125.728 74.6389C125.228 74.139 124.947 73.4613 124.946 72.7544Z"
      fill="#CCCCCC"
    />
    <path
      d="M93.3303 72.9448C93.3311 72.2379 93.6123 71.5601 94.1122 71.0603C94.612 70.5604 95.2898 70.2792 95.9967 70.2784H117.328C118.035 70.2784 118.713 70.5594 119.213 71.0594C119.713 71.5594 119.994 72.2376 119.994 72.9448C119.994 73.652 119.713 74.3302 119.213 74.8302C118.713 75.3302 118.035 75.6112 117.328 75.6112H95.9967C95.2898 75.6104 94.612 75.3292 94.1122 74.8293C93.6123 74.3295 93.3311 73.6517 93.3303 72.9448Z"
      fill="#CCCCCC"
    />
    <path
      d="M66.2856 72.9448C66.2864 72.2379 66.5676 71.5601 67.0675 71.0603C67.5673 70.5604 68.2451 70.2792 68.952 70.2784H85.3311C86.0383 70.2784 86.7165 70.5594 87.2165 71.0594C87.7166 71.5594 87.9975 72.2376 87.9975 72.9448C87.9975 73.652 87.7166 74.3302 87.2165 74.8302C86.7165 75.3302 86.0383 75.6112 85.3311 75.6112H68.952C68.2451 75.6104 67.5673 75.3292 67.0675 74.8293C66.5676 74.3295 66.2864 73.6517 66.2856 72.9448Z"
      fill="#CCCCCC"
    />
  </svg>
);
